import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {InstrumentedWBLogoLoader} from '../../components/utility/InstrumentedLoader';
import {isSpecificPath} from '../../routes';
import * as PATHS from '../../routes/paths';

const WORKSPACE_LOADING_TEXTS = [
  'Loading project...',
  'Gathering workspace settings...',
  'Loading runs...',
  'Generating visualizations...',
];

export const WorkspaceLoader = () => {
  return (
    <TailwindContents>
      <div
        className={twMerge(
          'fixed left-0 top-0 z-50',
          'flex items-center justify-center',
          'h-[100vh] w-[100vw] bg-[#FAFAFA]'
        )}>
        <InstrumentedWBLogoLoader
          name="workspace-loader"
          loadingTexts={WORKSPACE_LOADING_TEXTS}
        />
      </div>
    </TailwindContents>
  );
};

/**
 * Returns true if path should use WorkspaceLoader as initial loading screen.
 * Includes multi & single run workspaces, and full-screened panels on any workspace.
 * Does not include runs table page.
 */
export function isWorkspaceLoaderPath(path: string): boolean {
  return isSpecificPath(path, [
    // project page paths
    PATHS.PROJECT_BASE_PATH,
    PATHS.PROJECT_WORKSPACE_PATH,
    PATHS.FULL_SCREEN_WORKSPACE_PANEL_PATH,
    PATHS.FULL_SCREEN_WORKSPACE_TAB_PANEL_PATH,
    // run page paths
    PATHS.RUN_BASE_PATH,
    PATHS.RUN_WORKSPACE_PATH,
    PATHS.FULL_SCREEN_RUNS_PANEL_PATH,
    PATHS.FULL_SCREEN_RUNS_WORKSPACE_PANEL_PATH,
    // group page paths
    PATHS.GROUP_BASE_PATH,
    PATHS.GROUP_WORKSPACE_PATH,
    PATHS.FULL_SCREEN_GROUP_PANEL_PATH,
    PATHS.FULL_SCREEN_GROUP_WORKSPACE_TAB_PANEL_PATH,
    // sweep page paths
    PATHS.SWEEP_BASE_PATH,
    PATHS.SWEEP_WORKSPACE_PATH,
    PATHS.FULL_SCREEN_SWEEP_PANEL_PATH,
    PATHS.FULL_SCREEN_SWEEP_WORKSPACE_TAB_PANEL_PATH,
  ]);
}
